import React, { useState } from 'react'
import { HashLink } from "react-router-hash-link";

import MenuIcon from '@mui/icons-material/Menu';
import { Link, useHistory } from 'react-router-dom';
function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useHistory();
  const toggleMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  return (
    <div className=' p-4 sm:py-6 aling-center bg-black bg-opacity-40 fixed top-0 left-0 w-full z-10 backdrop-blur-sm'>
      <div className='lg:w-[95%] xl:w-[95%] 2xl:w-[90%]  m-auto  flex-row flex justify-between aling-center' >
        <div className='flex flex-row space-x-2  py-1 items-center h-full '>
          <img src='/logo.png' alt="logo" className=' h-6 sm:h-10 w-auto ' />
          <span className='text-white font-[700] text-md sm:text-2xl font-hemihead '>Fit Streak</span>
        </div>

        <div className="hidden lg:flex justify-between  md:w-[45%] lg:w-[45%] xl:w-[40%] p-2 text-nav_option font-semibold">
          <HashLink to="/#" className="hover:text-red text-lg">Home</HashLink>
          <HashLink to="/#MemberShip" className="hover:text-red text-lg">Membership</HashLink>
          {/* <a href="#Classes" className="hover:text-red text-sm">Program</a> */}
          <HashLink to="/#Aboutus" className="hover:text-red text-lg">About Us</HashLink>
          <HashLink to="/#ContactUs" className="hover:text-red text-lg">Contact</HashLink>
        </div>
        <div className='flex flex-row space-x-6'>
          <div className=" px-3  border border-red rounded-[8px] flex bg-red">
            <button
              className="text-white text-sm lg:text-base font-semibold text-center"
              onClick={() => {
                // Scroll smoothly to the element with id 'specialOffer'
                document.getElementById('specialOffer')?.scrollIntoView({
                  behavior: 'smooth',
                });
              }}
            >
              SPECIAL OFFER
            </button>


          </div>
          {/* <div className=" px-6 hidden border border-red rounded-[8px] sm:flex">

            <button className="text-white  text-sm lg:text-base font-semibold text-center " onClick={() => { navigate.push("/joinNow") }}>
              JOIN NOW
            </button>

          </div> */}
          <div className="lg:hidden flex items-center">
          <button onClick={toggleMenu} className="text-white">
            <MenuIcon fontSize='large' /> {/* Hamburger icon */}
          </button>
        </div>
        </div>



        {/* Mobile Menu Toggle */}

      </div>
      <div
        className={`${isMobileMenuOpen ? "block" : "hidden"
          } lg:hidden bg-black bg-opacity-0 text-nav_option space-y-2 px-8   transition-all duration-500 ease-in mt-2 font-semibold`}

      >
        <HashLink to="/#" className="block  p-2">Home</HashLink>
        <HashLink to="/#MemberShip" className="block  p-2">Membership</HashLink>
        {/* <a href="#Classes" className="block  p-2">Program</a> */}
        <HashLink to="/#Aboutus" className="block  p-2">About Us</HashLink>
        <HashLink to="/#ContactUs" className="block  p-2">Contact</HashLink>
      </div>
    </div>
  )
}

export default Navbar
